module.exports = __webpack_public_path__ + "img/banner-middle-4.b14d716d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-middle/banner-middle-4.jpg
// module id = gMFj
// module chunks = 1